import React from 'react';
import PropTypes from 'prop-types';
import { ProductsFeedsEmpty } from './ProductsFeedsEmpty';
import { ProductsFeedProcessing } from './ProductsFeedProcessing';
import styles from './ProductsFeedsTable.module.scss';
import { ProductsFeedRow } from './ProductsFeedRow';

export function ProductsFeedRowsRenderer({ rows, selected, onChange }) {
  if (rows.length === 0) {
    return <ProductsFeedsEmpty />;
  }

  let isEvenRow = true;

  return rows.map((row) => {
    isEvenRow = !isEvenRow;

    if (row.status === 'processing') {
      return (
        <ProductsFeedProcessing
          checked={selected.includes(row.batch_id)}
          onChange={onChange}
          key={row.batch_id}
          row={row}
          isEvenClassName={isEvenRow ? styles.rowEven : styles.rowOdd}
        />
      );
    }

    return (
      <ProductsFeedRow
        checked={selected.includes(row.batch_id)}
        onChange={onChange}
        row={row}
        key={row.batch_id}
        isEvenClassName={isEvenRow ? styles.rowEven : styles.rowOdd}
      />
    );
  });
}

ProductsFeedRowsRenderer.propTypes = {
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      batch_id: PropTypes.string.isRequired,
      created_at: PropTypes.string.isRequired,
      started_at: PropTypes.string,
      finished_at: PropTypes.string,
      created_count: PropTypes.number,
      updated_count: PropTypes.number,
      failed_count: PropTypes.number,
      report_url: PropTypes.string,
    }),
  ).isRequired,
  selected: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
};
